'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React__namespace.createElement("circle", {
    fill: "currentColor",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12.794 15.65h5.587v1.398h-5.587V15.65Zm1.396 5.588h-2.793V10.063h4.889v3.493h3.492v2.165l1.397-1.397v-1.467l-4.19-4.19h-5.588c-.772 0-1.397.625-1.397 1.396v11.175c0 .772.625 1.397 1.397 1.397h2.793v-1.397Zm-1.396-1.397h2.863l.629-.628v-.769h-3.492v1.397Zm8.52-3.492c.07 0 .21.07.28.14l.908.908c.14.14.14.419 0 .559l-.699.698-1.466-1.467.698-.698c.07-.07.14-.14.28-.14Zm0 2.724-4.26 4.26h-1.467v-1.466l4.26-4.26 1.467 1.466Z",
    fill: "#FFF"
  })));
});
var DocumentEditCircled = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.DocumentEditCircled = DocumentEditCircled;